import { gql } from 'graphql-request'
import { contentFragments, mapToContentCard } from '../content/all-content-list'
import { defaultsQuery } from '../globals/defaults'
import { CollectionType } from 'app/queries/collections/collection-fragment'
import { Pagination } from 'app/types/pagination'
import { ContentCardProps } from 'app/components/content/ContentCard'

export interface PaginationWithFeatured extends Pagination<ContentCardProps> {
  featured: ContentCardProps[]
}

export const createAllContentListQuery = () => gql`
  ${contentFragments}

  query getAllContent(
    $collection: String
    $contentTier: String
    $tag: String

    $sort: String

    $page: Int
    $limit: Int
    $featuredLimit: Int
  ) {
    contentList (
      collection: $collection
      contentTier: $contentTier
      tag: $tag

      sort: $sort

      page: $page
      limit: $limit
      featuredLimit: $featuredLimit
    ) {
      totalDocs
      page
      docs {
        ...content
      }
      featured {
        ...content
      }
    }

    ${defaultsQuery}
  }
`

export const typeToVariable = (type?: CollectionType, id?: string) => {
  if (type === 'MemberTier') {
    return { contentTier: id }
  }

  if (!type || !id) {
    return {}
  }

  return { [type.toLowerCase()]: id }
}

export function mapContentPagination(res, data: any) {
  const docs = res.docs.map((item: any) =>
    mapToContentCard(item, data?.Defaults)
  )

  const featured = res.featured.map((item: any) =>
    mapToContentCard(item, data?.Defaults)
  )

  return {
    total: res.totalDocs,
    page: res.page,
    docs,
    featured,
  }
}

export const contentListQueryToContentList = (
  data: any
): PaginationWithFeatured => {
  const res = data.contentList
  return mapContentPagination(res, data)
}
